module.exports = __webpack_public_path__ + "static/bellchat.f0290aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellchat.png
// module id = 1254
// module chunks = 35783957827783